// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"d9f3aeffa9eda412c241","883":"5ecdf15eb566334d0a07"}[chunkId] + ".js";
};